export const makeId = (url: string, suffix: string): string => {
  if (!url) return `#${suffix}`

  const urlObject = new URL(url)
  urlObject.pathname = urlObject.pathname.replace(/\/?$/, '/')
  return `${urlObject.toString()}#${suffix}`
}

export const getBaseDomain = (canonicalUrl: string): string => {
  if (!canonicalUrl) return ''

  const url = new URL(canonicalUrl)
  return `${url.protocol}//${url.host}`.replace(/\/$/, '')
}
